import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../scss/dashboard.scss';
import Header from '../components/header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faTint } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import BaseURL from '../assets/contants/BaseURL';
import Spinner from '../components/Spinner';

const Flowportal = () => {
    const navigate = useNavigate();
    const [meterData, setMeterData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const metersResponse = await axios.get(`${BaseURL}meters/flowmeters/`);

                const today = new Date();
                const indiaTime = new Date(today.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
                const formattedDate = `${indiaTime.getFullYear()}-${(indiaTime.getMonth() + 1).toString().padStart(2, '0')}-${indiaTime.getDate().toString().padStart(2, '0')}`;

                const dataResponse = await axios.post(`${BaseURL}data/flow-watermeter-table/`, {
                    date: formattedDate,
                });

                const processedData = {
                    ...dataResponse.data,
                    flow_meters: dataResponse.data.flow_meters
                        .map(meter => ({
                            ...meter,
                            meter_name: metersResponse.data.find(fm => fm.flow_meter_id === meter.meter_id)?.flow_meter_name || meter.meter_id
                        }))
                        .sort((a, b) => {
                            const numA = parseInt(a.meter_id.replace(/\D/g, ''), 10);
                            const numB = parseInt(b.meter_id.replace(/\D/g, ''), 10);
                            return numA - numB;
                        })
                };

                setMeterData(processedData);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const getDisplayUnit = (unit) => {
        switch (unit) {
            case 'kilo': return 'KL';
            case 'mega': return 'ML';
            default: return 'L';
        }
    };

    const handleMeterClick = (meterId) => {
        navigate("/EMS/flowsub", { state: { meterId } });
        window.scrollTo(0, 0);
    };

    const handleMainClick = (type) => {
        if (type === "meters") {
            navigate("/EMS/flowmeter");
        }
    };

    const renderWidget = (title, value, icon, onClick, color = '#0093ff') => (
        <div
            onClick={onClick}
            style={{
                width: '150px',
                height: '80px',
                margin: '10px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                borderRadius: '15px',
                border: '1px solid #ddd',
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                position: 'relative',
                textAlign: 'left',
                padding: '15px',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                backgroundColor: color
            }}
            className="widgetss"
        >
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                {icon && <FontAwesomeIcon icon={icon} size="3x" style={{ color: '#fff' }} />}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 'bold', color: '#fff' }}>{title}</h4>
                    <p style={{ fontSize: '1rem', color: '#fff', fontWeight: '400' }}>{value}</p>
                </div>
            </div>
        </div>
    );

    const renderSummaryWidgets = () => {
        if (!meterData) return null;

        return (
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '20px',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '20px',
            }}>
                {renderWidget(
                    'Total Meters',
                    meterData.total_flow_meters,
                    faLayerGroup,
                    () => handleMainClick('meters'),
                    '#4a6baf'
                )}
                {renderWidget(
                    'Total Daily Flow',
                    `${(meterData.total_daily_liters).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})} L`,
                    faTint,
                    null,
                    '#3aa8a1'
                )}
            </div>
        );
    };

    const FlowMeterAnimation = ({ currentLiters, unit_type }) => {
        return (
            <div style={{ margin: '20px 0' }}>
                <svg
                    width="200"
                    height="200"
                    viewBox="0 0 300 210"
                    preserveAspectRatio="xMidYMid meet"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {/* Define the clip path for the tank */}
                    <defs>
                        <clipPath id="tankClip">
                            <rect x="97.5" y="157.5" width="105" height="60" rx="7.5" ry="7.5" />
                        </clipPath>
                        
                        <linearGradient id="pipeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stopColor="white" stopOpacity="0.3" />
                            <stop offset="100%" stopColor="white" stopOpacity="0" />
                        </linearGradient>
                    </defs>

                    {/* Left pipe */}
                    <path d="M15 145 Q30 115 45 145 L45 235 Q30 265 15 235 Z" fill="#4a8bc9" stroke="#005a9e" strokeWidth="3" />
                    <rect x="45" y="145" width="30" height="90" fill="#4a8bc9" stroke="#005a9e" strokeWidth="3" />
                    <rect x="45" y="145" width="30" height="90" fill="url(#pipeGradient)" opacity="0.7" />
                    
                    {/* Right pipe */}
                    <path d="M285 145 Q270 115 255 145 L255 235 Q270 265 285 235 Z" fill="#4a8bc9" stroke="#005a9e" strokeWidth="3" />
                    <rect x="225" y="145" width="30" height="90" fill="#4a8bc9" stroke="#005a9e" strokeWidth="3" />
                    <rect x="225" y="145" width="30" height="90" fill="url(#pipeGradient)" opacity="0.7" />
                    
                    {/* Center tank */}
                    <rect x="75" y="135" width="150" height="105" rx="15" ry="15" fill="#4a8bc9" stroke="#005a9e" strokeWidth="4.5" />
                    <rect x="75" y="150" width="30" height="75" fill="#4a8bc9" />
                    <rect x="195" y="150" width="30" height="75" fill="#4a8bc9" />
                    <rect x="97.5" y="157.5" width="105" height="60" rx="7.5" ry="7.5" fill="#cce6ff" />
                    
                    {/* Pipe to meter */}
                    <rect x="125" y="37.5" width="50" height="105" fill="#4a8bc9" stroke="#005a9e" strokeWidth="3" rx="4.5" ry="4.5" />
                    <rect x="125" y="37.5" width="50" height="105" fill="url(#pipeGradient)" opacity="0.7" />
                    
                    {/* Meter */}
                    <circle cx="150" cy="30" r="70" fill="#d9d9d9" stroke="#777" strokeWidth="6" />
                    <circle cx="150" cy="30" r="55" fill="#a9d0f5" stroke="#555" strokeWidth="3" />
                    <rect x="104" y="15" width="92" height="35" rx="22.5" ry="22.5" fill="#ffffff" stroke="#777" strokeWidth="1" />
                    
                    {/* Current liters display */}
                    <text 
                        x="155" 
                        y="35" 
                        textAnchor="middle" 
                        dominantBaseline="middle" 
                        fill="#333" 
                        fontFamily="Arial" 
                        fontSize="14" 
                        fontWeight="bold"
                    >
                        {currentLiters.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})} {getDisplayUnit(unit_type)}
                    </text>

                    {/* Enhanced water flow animation - more lines with varied properties */}
                    <g clipPath="url(#tankClip)">
                        {Array.from({ length: 20 }).map((_, index) => {
                            const yPos = 158 + (index * 3);
                            const width = 10 + (Math.random() * 10);
                            const height = 2 + (Math.random() * 1.5);
                            const speed = 0.5 + (Math.random() * 0.7);
                            const delay = index * 0.05;
                            
                            return (
                                <rect
                                    key={index}
                                    x="45"
                                    y={yPos}
                                    width={width}
                                    height={height}
                                    fill="#0077ff"
                                    opacity={0.4 + (Math.random() * 0.4)}
                                    rx={height/2}
                                    ry={height/2}
                                >
                                    <animate
                                        attributeName="x"
                                        values={`45;202.5`}
                                        dur={`${speed}s`}
                                        repeatCount="indefinite"
                                        begin={`${delay}s`}
                                    />
                                    <animate
                                        attributeName="opacity"
                                        values={`${0.3 + (index * 0.02)};0.8;${0.3 + (index * 0.02)}`}
                                        dur={`${speed * 1.5}s`}
                                        repeatCount="indefinite"
                                        begin={`${delay}s`}
                                    />
                                </rect>
                            );
                        })}
                    </g>
                </svg>
            </div>
        );
    };

    const renderMeterWidgets = () => {
        if (!meterData?.flow_meters) return null;

        return (
            <div style={{ marginBottom: '20px' }}>
                <div style={{
                    width: '100%',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '20px',
                    justifyContent: 'center',
                }}>
                    {meterData.flow_meters.map((meter) => (
                        <div
                            key={meter.meter_id}
                            onClick={() => handleMeterClick(meter.meter_id)}
                            style={{
                                width: '450px',
                                height: '300px',
                                background: '#047BC4',
                                borderRadius: '10px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '20px',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                textAlign: 'center',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                cursor: 'pointer',
                            }}
                            className="widget"
                        >

                            <h4 style={{
                                margin: '5px 0',
                                color: '#fff',
                                textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                                fontSize: '16px',
                            }}>
                                {meter.meter_name}
                            </h4>
                            {/* <img 
                                src="Magnetic-Flowmeter.jpeg" 
                                alt="Flow Meter" 
                                style={{
                                    maxWidth: '100%',
                                    height: 'auto',
                                    borderRadius: '8px',
                                    marginBottom: '15px',
                                }}
                            /> */}
                            <FlowMeterAnimation 
                                currentLiters={meter.current_liters} 
                                unit_type={meter.unit_type} 
                            />
                            <p
                                style={{
                                    margin: '0',
                                    color: '#fff',
                                    fontWeight: '600',
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                                    fontSize: '12px',
                                }}
                            >
                                Todays Liters: {(meter.daily_liters).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2}) || 0} {getDisplayUnit(meter.unit_type)}
                            </p>
                            <p
                                style={{
                                    margin: '0',
                                    color: '#fff',
                                    fontWeight: '600',
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                                    fontSize: '12px',
                                }}
                            >
                                Current Liters: {(meter.current_liters).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2}) || 0} {getDisplayUnit(meter.unit_type)}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className="dashboard-container">
            <Header title="BRADKEN WATER FLOW MANAGEMENT DASHBOARD" />
            <div className="card-container" style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                marginTop: '50px',
                maxWidth: '1000px',
                marginLeft: 'auto',
                marginRight: 'auto'
            }}>
                <div className="card" style={{ background: '#fff', borderRadius: '10px' }}>
                    {loading ? (
                        <div className="loading-spinner">
                            <Spinner />
                        </div>
                    ) : (
                        <>
                            {renderSummaryWidgets()}
                            <h3 className="dashboard-subtitle" style={{ textAlign: 'center', margin: '20px 0' }}>
                                Flow Meters
                            </h3>
                            {renderMeterWidgets()}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Flowportal;